import { BaseQueryFn } from '@reduxjs/toolkit/query/react'
import { ClientError, GraphQLClient } from 'graphql-request'
import { DocumentNode } from 'graphql'
import { GraphqlRequestBaseQueryArgs } from './types'
import { LinkInput } from '@dtx-company/flow-codegen/src/page/generated.types'
import { PAGE_GATE_TYPES } from '@dtx-company/true-common/src/constants/gate'

/** this is a modified version of graphqlRequestBaseQuery from @rtk-query/graphql-request-base-query to modify request headers for authentication */
export const graphqlRequestBaseQuery = ({
  options
}: GraphqlRequestBaseQueryArgs): BaseQueryFn<
  { document: string | DocumentNode; variables?: any; authOnly?: boolean },
  unknown,
  Pick<ClientError, 'name' | 'message' | 'stack'>,
  Partial<Pick<ClientError, 'request' | 'response'>>
> => {
  const client = new GraphQLClient(options.url, { credentials: 'include' })

  return async ({ document, variables }) => {
    try {
      const data = await client.request(document, variables)
      return { data, meta: {} }
    } catch (error) {
      if (error instanceof ClientError) {
        const { name, message, stack, request, response } = error
        console.error(`GQL error flowpage api: `, { name, message, stack, request, response })
        return { error: { name, message, stack }, meta: { request, response } }
      }
      throw error
    }
  }
}

export const checkGateId = (linkInput: LinkInput, currGateId?: string | null): string | null => {
  let gateId: string | null | undefined = currGateId
  if (linkInput?.type && PAGE_GATE_TYPES.includes(linkInput?.type)) {
    if (linkInput.type === 'contactCollection') {
      if (linkInput.displayType === 'popup') gateId = linkInput.id
      else if (currGateId === linkInput.id) gateId = null
    } else {
      gateId = linkInput.id
    }
  }
  return gateId ?? null
}
